import { projConstants } from "../constants";

const initialState = {
  projects: [],
  selectedProject: {},
  // authenticates every image url of the opened project, see getter.getViewpointThumbnailUrl
  resourceToken: null,
};

export function project(state = initialState, action) {
  switch (action.type) {
    case projConstants.PROJ_GETAll: {
      return {
        ...state,
        projects: action.payload,
      };
    }
    case projConstants.PROJ_OPEN: {
      if (JSON.stringify(state.selectedProject) === "{}") {
        return {
          ...state,
          selectedProject: action.payload,
        };
      } else {
        return {
          ...state,
          selectedProject: {
            ...state.selectedProject,
            ...action.payload,
          },
        };
      }
    }
    case projConstants.PROJ_CLEAR: {
      return initialState;
    }
    case projConstants.PROJ_RETURN: {
      return {
        ...state,
        selectedProject: {},
        resourceToken: null,
      };
    }
    case projConstants.PROJ_SET_RESOURCE_TOKEN: {
      return {
        ...state,
        resourceToken: action.payload,
      };
    }
    case projConstants.PROJ_RESETISSUEFLAG: {
      return state;
    }

    default:
      return state;
  }
}
